import { combineReducers } from "redux";
import { USER_SIGNED_OUT } from "../user/types";
import * as types from "./types";

const highlightSummaryFetchingReducer = (state = false, action) => {
  switch (action.type) {
    case types.GET_HIGHLIGHT_SUMMARY_REQUEST:
      return true;
    case types.GET_HIGHLIGHT_SUMMARY_SUCCESS:
    case types.GET_HIGHLIGHT_SUMMARY_ERROR:
      return false;
    default:
      return state;
  }
};

const highlightSummaryIsLoadedReducer = (state = false, action) => {
  switch (action.type) {
    case types.GET_HIGHLIGHT_SUMMARY_SUCCESS:
      return true;
    case types.GET_HIGHLIGHT_SUMMARY_ERROR:
      return false;
    case USER_SIGNED_OUT:
      return false;
    default:
      return state;
  }
};

const highlightSummaryDataReducer = (state = [], action) => {
  switch (action.type) {
    case types.GET_HIGHLIGHT_SUMMARY_SUCCESS:
      return action.data;
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const highlightSummaryReducer = combineReducers({
  isFetching: highlightSummaryFetchingReducer,
  isLoaded: highlightSummaryIsLoadedReducer,
  summary: highlightSummaryDataReducer
});

export default highlightSummaryReducer;
